"use strict";

const SELECTED_PRODUCTS_LIMIT = 5;
const TABLE_COLUMN_WIDTH = 190;
export { SELECTED_PRODUCTS_LIMIT, TABLE_COLUMN_WIDTH };
//# sourceMappingURL=constants.mjs.map
